import * as React from "react";
import { LearnMoreResources, TopicsContainer } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonViews";
import ExternalLink from "~/components/Navigation/ExternalLink";
export const InsightsReportListTopics = () => (<TopicsContainer>
        <LearnMoreResources>
            <div>
                <ExternalLink href="InsightsReports">Insights Reports</ExternalLink>
            </div>
        </LearnMoreResources>
    </TopicsContainer>);
